import React, { memo, useState } from 'react';
import { NodeProps } from 'reactflow';

interface AnnotationNodeData {
  text: string;
  color: string;
  onDelete?: (id: string) => void;
}

const AnnotationNode: React.FC<NodeProps<AnnotationNodeData>> = ({ 
  id, 
  data,
  selected
}) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div 
      className={`annotation-node rounded-lg shadow-md p-3 max-w-xs ${
        selected ? 'ring-2 ring-blue-500' : ''
      }`}
      style={{ backgroundColor: data.color }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="flex justify-between items-start">
        <div className="text-sm whitespace-pre-wrap">{data.text}</div>
        
        {(isHovered || selected) && data.onDelete && (
          <button
            className="ml-2 text-gray-700 hover:text-gray-900"
            onClick={() => data.onDelete(id)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default memo(AnnotationNode);
